import React, { useState } from "react";
import { Grid, Card, CardMedia, Typography, Box, Button } from "@mui/material";
import carousel1 from "../../assets/img/carousel1.png";
import carousel2 from "../../assets/img/carousel2.png";
import carousel3 from "../../assets/img/carousel3.png";
import carousel4 from "../../assets/img/carousel4.png";
import carousel5 from "../../assets/img/carousel5.png";
import carousel6 from "../../assets/img/product-images/tanker2.jpg";
import carousel7 from "../../assets/img/product-images/tanker1.jpg";
import leftarrow from "../../assets/img/leftarrow.png";
import rightarrow from "../../assets/img/rightarrow.png";

const ServiceBanner = () => {
  const services = [
    { title: "Door Step Delivery", image: carousel1 },
    { title: "Place Order For Sports & Tournaments", image: carousel7 },
    { title: "Lab Verified Purify Water", image: carousel2 },
    { title: "Offers Packaged Water Bottles", image: carousel6 },
    { title: "Lab Verified Purify Water", image: carousel2 },
    { title: "Bulk Order For Events", image: carousel3 },
  ];

  const [currentIndex, setCurrentIndex] = useState(0);
  const visibleCards = 3;

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex + visibleCards >= services.length ? 0 : prevIndex + 1
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? services.length - visibleCards : prevIndex - 1
    );
  };

  return (
    <Box
      sx={{
        padding: "0 10vw",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      {/* Left Arrow Button */}
      <Button
        onClick={handlePrev}
        sx={{
          backgroundColor: "#fff",
          boxShadow: "none",
          marginTop:'-4rem',
          "&:hover": { backgroundColor: "#fff" },
        }}
      >
        <img
          src={leftarrow}
          alt="Previous"
          style={{
            width: "40px",
            height: "40px",
            transform: "rotate(180deg)", // Rotates the image 180 degrees
          }}
        />
      </Button>

      {/* Cards Section */}
      <Grid container spacing={3} justifyContent="center" sx={{ flexGrow: 1 }}>
        {services
          .slice(currentIndex, currentIndex + visibleCards)
          .map((service, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <Card
                  sx={{
                    width: "100%",
                    maxWidth: 360,
                    height: "220px",
                    borderRadius: "10px",
                    overflow: "hidden",
                    boxShadow: "0px 4px 4px 0px #00000040",
                  }}
                >
                  <CardMedia
                    component="img"
                    image={service.image}
                    alt={service.title}
                    sx={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                </Card>
                <Typography
                  variant="h6"
                  sx={{
                    marginTop: 2,
                    color: "gray",
                    fontWeight: "500",
                    maxWidth: 360,
                    wordWrap: "break-word",
                  }}
                >
                  {service.title}
                </Typography>
              </Box>
            </Grid>
          ))}
      </Grid>

      {/* Right Arrow Button */}
      <Button
        onClick={handleNext}
        sx={{
          backgroundColor: "#fff",
          marginTop:'-4rem',
          boxShadow: "none",
          "&:hover": { backgroundColor: "#fff" },
        }}
      >
        <img
          src={rightarrow}
          alt="Next"
          style={{ width: "40px", height: "40px" }}
        />
      </Button>
    </Box>
  );
};

export default ServiceBanner;
